import React, { useState, useRef, useEffect } from "react";
import Paginador from "./Paginador";

const ProductTable = ({
  products,
  selectedProducts,
  setSelectedProducts,
  onSelectionChange,
  onEditProduct,
  onDeleteProduct,
  onCellClick,
  onDuplicateProduct,
}) => {
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [openMenuId, setOpenMenuId] = useState(null);
  const totalItems = products.length;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentProducts = products.slice(startIndex, startIndex + itemsPerPage);
  const actionsRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (
        openMenuId !== null &&
        actionsRef.current &&
        !actionsRef.current.contains(e.target)
      ) {
        setOpenMenuId(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openMenuId]);

  // Selección
  const handleCheckboxChange = (id) => {
    const upd = { ...selectedProducts, [id]: !selectedProducts[id] };
    setSelectedProducts(upd);
    onSelectionChange(upd);
  };
  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    const newSel = currentProducts.reduce((m, p) => {
      m[p.id] = checked;
      return m;
    }, {});
    setSelectedProducts(newSel);
    onSelectionChange(newSel);
  };

  // Paginador
  const handlePageChange = (p) => setCurrentPage(p);
  const handleItemsPerPageChange = (n) => {
    setItemsPerPage(n);
    setCurrentPage(1);
  };

  return (
    <div className="cotizaciones-table">
      <div className="tabla-cotizaciones-wrapper">
        <div className="tabla-cotizaciones-content">
          <table className="cotizaciones-table__table">
            {/* 1. DEFINIMOS LAS COLUMNAS CON ANCHO FIJO */}
            <colgroup>
              <col style={{ width: 40 }} /> {/* Checkbox */}
              <col style={{ width: 200 }} /> {/* Descripción */}
              <col style={{ width: 160 }} /> {/* Modelo / No. Parte */}
              <col style={{ width: 140 }} /> {/* Categoría */}
              <col style={{ width: 110 }} /> {/* Precio */}
              <col style={{ width: 120 }} /> {/* Existencias */}
              <col style={{ width: 80 }} /> {/* Acciones */}
            </colgroup>

            <thead>
              <tr>
                <th className="check">
                  <input
                    type="checkbox"
                    className="checkbox-select-all check"
                    onChange={handleSelectAll}
                    checked={
                      currentProducts.length > 0 &&
                      currentProducts.every((p) => selectedProducts[p.id])
                    }
                  />
                </th>

                <th className="th-descripcion sortable">Descripción</th>
                <th>Número de Parte</th>
                <th className="sortable">Categoría</th>
                <th className="sortable">Precio</th>
                <th className="sortable">Existencias</th>
                <th style={{ textAlign: "center", padding: "0 12px" }}>
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody>
              {currentProducts.map((product) => (
                <tr
                  key={product.id}
                  style={{ cursor: "pointer" }}
                  onClick={() => onCellClick(product.id)}
                >
                  <td className="check" onClick={(e) => e.stopPropagation()}>
                    <input
                      type="checkbox"
                      className="checkbox"
                      checked={!!selectedProducts[product.id]}
                      onChange={() => handleCheckboxChange(product.id)}
                    />
                  </td>

                  <td className="product-name-cell">
                    <img
                      src={product.imagen}
                      alt={product.nombre}
                      className="tableProducts-image"
                    />
                    <div>
                      <div className="description-text">{product.nombre}</div>
                      <div className="model-text">Modelo: {product.modelo}</div>
                    </div>
                  </td>
                  <td>{product.numeroDeParteProveedor}</td>
                  <td>{product.categoria || "Ninguna"}</td>
                  <td>
                    {parseFloat(product.costo)
                      .toFixed(2)
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </td>
                  <td
                    className="existencias-cell"
                    style={{ textAlign: "center", verticalAlign: "middle" }}
                  >
                    {product.existencias ?? 0}
                  </td>
                  <td
                    ref={openMenuId === product.id ? actionsRef : null}
                    className="acciones-cell"
                    style={{
                      position: "relative",
                      textAlign: "center",
                      padding: "0 12px",
                    }}
                    onClick={(e) => e.stopPropagation()} // no dejar que la fila lo capture
                  >
                    <div className="menu-container">
                      <i
                        className="bi bi-three-dots"
                        role="button"
                        tabIndex={0}
                        aria-haspopup="menu"
                        aria-expanded={openMenuId === product.id}
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenMenuId(
                            openMenuId === product.id ? null : product.id
                          );
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            e.stopPropagation();
                            setOpenMenuId(
                              openMenuId === product.id ? null : product.id
                            );
                          }
                        }}
                        style={{
                          cursor: "pointer",
                          fontSize: 20,
                          color: "#6B7280",
                        }}
                      />

                      {openMenuId === product.id && (
                        <div
                          className="menu-list"
                          role="menu"
                          onClick={(e) => e.stopPropagation()} // clicks dentro no burbujean
                        >
                          <button
                            className="menu-button"
                            role="menuitem"
                            onClick={(e) => {
                              e.stopPropagation();
                              onEditProduct(product.id);
                              setOpenMenuId(null);
                            }}
                          >
                            <i
                              className="bi bi-pencil"
                              style={{ marginRight: 6 }}
                            />
                            Editar
                          </button>

                          <button
                            className="menu-button"
                            role="menuitem"
                            onClick={(e) => {
                              e.stopPropagation();
                              onDuplicateProduct(product.id);
                              setOpenMenuId(null);
                            }}
                          >
                            <i
                              className="bi bi-files"
                              style={{ marginRight: 6 }}
                            />
                            Duplicar
                          </button>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="tabla-cotizaciones-footer">
          <Paginador
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            onItemsPerPageChange={handleItemsPerPageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductTable;
